import React, { Component } from 'react';
import { Table, Row, Select, Button, message, InputNumber } from 'antd';
import moment from 'moment';
import './index.scss';
import imgSave from "../../../bp-views/table/saveImg";
import { data2_1 } from './data';
import Auth from "../../table/Auth";
import TableText from "../../../hr/components/TableText";

const Option = Select.Option;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        const month = moment().format('M');
        this.state = {
            date: month < 3 ? moment().format('YYYY') : moment().add(1, 'y').format('YYYY'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            dateData: [],
            cover: 0,
        }
    }

    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        }
        // 计算year的行总和
        const totalIndex = [0, 1, 2, 7, 8, 9, 12, 13, 16, 17, 18, 21, 22, 23, 26, 27, 28, 38, 39, 40, 41, 44, 45, 46, 47, 48, 52, 53, 54, 57, 58, 59];
        const totalName = ['Jan_actual', 'Feb_actual', 'Mar_actual', 'Jan_budget', 'Feb_budget', 'Mar_budget', 'Jan_forecast', 'Feb_forecast', 'Mar_forecast'];
        for (let i = 0; i < totalName.length; i++) {
            data[1][totalName[i]] = (numConvert(data[0][totalName[i]]) * numConvert(data[0].cover)).toFixed(2);
        }

        for (let i = 0; i < totalIndex.length; i++) {
            data[totalIndex[i]].total = totalName.reduce((a, b) => {
                a += numConvert(data[totalIndex[i]][b]);
                return a
            }, 0).toFixed(2);
        }

        const uniteIndex = [3, 4, 5, 10, 14, 19, 24, 29, 30, 32, 33, 34, 35, 42, 48, 49, 50, 51, 55, 60, 61, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74];
        const uniteName = ['Jan_actual', 'Jan_forecast', 'Jan_budget', 'Feb_actual', 'Feb_forecast', 'Feb_budget', 'Mar_actual', 'Mar_forecast', 'Mar_budget', 'total'];
        // 每行计算方式不同，无法统一循环
        for (let i = 0; i < uniteName.length; i++) {
            data[3][uniteName[i]] = (numConvert(data[1][uniteName[i]]) == 0 ? 0 : numConvert(data[2][uniteName[i]]) / numConvert(data[1][uniteName[i]])).toFixed(3);
            data[4][uniteName[i]] = (numConvert(data[2][uniteName[i]]) == 0 ? 0 : numConvert(data[7][uniteName[i]]) / numConvert(data[2][uniteName[i]])).toFixed(2);
            data[5][uniteName[i]] = (numConvert(data[4][uniteName[i]]) * numConvert(data[3][uniteName[i]])).toFixed(2);
            data[10][uniteName[i]] = (numConvert(data[9][uniteName[i]]) + numConvert(data[8][uniteName[i]]) + numConvert(data[7][uniteName[i]])).toFixed(2);
            data[14][uniteName[i]] = (numConvert(data[12][uniteName[i]]) + numConvert(data[13][uniteName[i]])).toFixed(2);
            data[19][uniteName[i]] = (numConvert(data[18][uniteName[i]]) + numConvert(data[17][uniteName[i]]) + numConvert(data[16][uniteName[i]])).toFixed(2);
            data[24][uniteName[i]] = (numConvert(data[23][uniteName[i]]) + numConvert(data[22][uniteName[i]]) + numConvert(data[21][uniteName[i]])).toFixed(2);
            data[29][uniteName[i]] = (numConvert(data[28][uniteName[i]]) + numConvert(data[27][uniteName[i]]) + numConvert(data[26][uniteName[i]])).toFixed(2);
            data[30][uniteName[i]] = (numConvert(data[29][uniteName[i]]) + numConvert(data[24][uniteName[i]]) + numConvert(data[19][uniteName[i]]) + numConvert(data[14][uniteName[i]])).toFixed(2);
            data[32][uniteName[i]] = (numConvert(data[7][uniteName[i]]) - numConvert(data[16][uniteName[i]]) - numConvert(data[21][uniteName[i]]) - numConvert(data[26][uniteName[i]])).toFixed(2);
            data[33][uniteName[i]] = (numConvert(data[8][uniteName[i]]) - numConvert(data[12][uniteName[i]]) - numConvert(data[17][uniteName[i]]) - numConvert(data[22][uniteName[i]]) - numConvert(data[27][uniteName[i]])).toFixed(2);
            data[34][uniteName[i]] = (numConvert(data[9][uniteName[i]]) - numConvert(data[13][uniteName[i]]) - numConvert(data[18][uniteName[i]]) - numConvert(data[23][uniteName[i]]) - numConvert(data[28][uniteName[i]])).toFixed(2);
            data[35][uniteName[i]] = (numConvert(data[34][uniteName[i]]) + numConvert(data[33][uniteName[i]]) + numConvert(data[32][uniteName[i]])).toFixed(2);
            data[42][uniteName[i]] = (numConvert(data[41][uniteName[i]]) + numConvert(data[40][uniteName[i]]) + numConvert(data[39][uniteName[i]]) + numConvert(data[38][uniteName[i]])).toFixed(2);
            data[49][uniteName[i]] = (numConvert(data[48][uniteName[i]]) + numConvert(data[47][uniteName[i]]) + numConvert(data[46][uniteName[i]]) + numConvert(data[45][uniteName[i]]) + numConvert(data[44][uniteName[i]])).toFixed(2);
            data[50][uniteName[i]] = (numConvert(data[42][uniteName[i]]) + numConvert(data[49][uniteName[i]])).toFixed(2);
            data[51][uniteName[i]] = (numConvert(data[35][uniteName[i]]) - numConvert(data[50][uniteName[i]])).toFixed(2);
            data[55][uniteName[i]] = (numConvert(data[51][uniteName[i]]) - numConvert(data[52][uniteName[i]]) - numConvert(data[53][uniteName[i]]) - numConvert(data[54][uniteName[i]])).toFixed(2);
            data[60][uniteName[i]] = (numConvert(data[59][uniteName[i]]) + numConvert(data[58][uniteName[i]]) + numConvert(data[57][uniteName[i]])).toFixed(2);
            data[61][uniteName[i]] = (numConvert(data[55][uniteName[i]]) - numConvert(data[60][uniteName[i]])).toFixed(2);
            data[63][uniteName[i]] = (numConvert(data[7][uniteName[i]]) == 0 ? 0 : numConvert(data[32][uniteName[i]]) / numConvert(data[7][uniteName[i]])).toFixed(3);
            data[64][uniteName[i]] = (numConvert(data[8][uniteName[i]]) == 0 ? 0 : numConvert(data[33][uniteName[i]]) / numConvert(data[8][uniteName[i]])).toFixed(3);
            data[65][uniteName[i]] = (numConvert(data[10][uniteName[i]]) == 0 ? 0 : numConvert(data[19][uniteName[i]]) / numConvert(data[10][uniteName[i]])).toFixed(3);
            data[66][uniteName[i]] = (numConvert(data[10][uniteName[i]]) == 0 ? 0 : numConvert(data[42][uniteName[i]]) / numConvert(data[10][uniteName[i]])).toFixed(3);
            data[67][uniteName[i]] = (numConvert(data[65][uniteName[i]]) + numConvert(data[66][uniteName[i]])).toFixed(3);
            data[68][uniteName[i]] = (numConvert(data[8][uniteName[i]]) == 0 ? 0 : numConvert(data[12][uniteName[i]]) / numConvert(data[8][uniteName[i]])).toFixed(3);
            data[69][uniteName[i]] = (numConvert(data[10][uniteName[i]]) == 0 ? 0 : numConvert(data[48][uniteName[i]]) / numConvert(data[10][uniteName[i]])).toFixed(3);
            data[70][uniteName[i]] = (numConvert(data[10][uniteName[i]]) == 0 ? 0 : (numConvert(data[12][uniteName[i]]) + numConvert(data[19][uniteName[i]]) + numConvert(data[42][uniteName[i]]) + numConvert(data[48][uniteName[i]])) / numConvert(data[10][uniteName[i]])).toFixed(3);
            data[71][uniteName[i]] = (numConvert(data[7][uniteName[i]]) - numConvert(data[32][uniteName[i]])).toFixed(2);
            data[72][uniteName[i]] = (numConvert(data[8][uniteName[i]]) - numConvert(data[33][uniteName[i]])).toFixed(2);
            if (uniteName[i] == 'total') {
                data[73][uniteName[i]] = ((numConvert(data[10][uniteName[i]]) - numConvert(data[55][uniteName[i]])) / 12).toFixed(2);
            } else {
                data[73][uniteName[i]] = (numConvert(data[10][uniteName[i]]) - numConvert(data[55][uniteName[i]])).toFixed(2);
            }
            data[74][uniteName[i]] = (numConvert(data[19][uniteName[i]]) + numConvert(data[42][uniteName[i]])).toFixed(2);
        }

        // 计算三
        this.setState({
            data,
            loading: false
        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data2_1);
        let data = JSON.parse(dataBegin);
        try {
            let bp = await fetch(`/chart_first_lst?year=${moment(date).format('YYYY')}`, { credentials: 'include' });
            let data1_1 = await bp.json();

            if (data1_1.data && data1_1.data.length > 0) {
                data = data1_1.data;
            }

            this.computeNum(data);
        } catch (error) {
            this.setState({ loading: false });
            console.error(error);
        }
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");

        let data = [...this.state.data.map(x => ({ ...x, year }))];
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/chart_first_add', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败！');
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table2_1', 1.5, '0.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth > 1925 ? document.body.offsetWidth - 1500 : 425;
        const inputIndex = [0, 2, 7, 8, 9, 12, 13, 16, 17, 18, 21, 22, 23, 26, 27, 28, 38, 39, 40, 41, 44, 45, 46, 47, 48, 52, 53, 54, 57, 58, 59];
        const percentData = [3, 63, 64, 65, 66, 67, 68, 69, 70];
        const totalData = [10, 35, 55];
        const blankData = [6, 11, 15, 20, 25, 31, 36, 37, 43, 56, 62];
        const columns = [
            {
                align: "center",
                title: '',
                width,
                fixed: "left",
                dataIndex: 'name',
                key: 'name',
                width,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: totalData,

                    };
                    if (blankData.includes(index)) {
                        return {
                            props: { colSpan: 16 },
                            children: <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                {text}
                            </div>
                        }
                    }

                    return <TableText data={{ ...props }} />
                }
            }, {
                title: this.state.date - 1,
                align: "center",
                children: [{
                    title: "Jan",
                    align: "center",
                    children: [{
                        title: 'Actual',
                        align: "center",
                        dataIndex: 'Jan_actual',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Jan_actual", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }, {
                        title: 'Budget',
                        align: "center",
                        dataIndex: 'Jan_budget',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Jan_budget", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }, {
                        title: 'Forecast',
                        align: "center",
                        dataIndex: 'Jan_forecast',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Jan_forecast", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }]
                }]
            }, {
                title: this.state.date - 1,
                align: "center",
                children: [{
                    title: "Feb",
                    align: "center",
                    children: [{
                        title: 'Actual',
                        align: "center",
                        dataIndex: 'Feb_actual',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Feb_actual", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }, {
                        title: 'Budget',
                        align: "center",
                        dataIndex: 'Feb_budget',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Feb_budget", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }, {
                        title: 'Forecast',
                        align: "center",
                        dataIndex: 'Feb_forecast',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Feb_forecast", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }]
                }]
            }, {
                title: this.state.date - 1,
                align: "center",
                children: [{
                    title: "Mar",
                    align: "center",
                    children: [{
                        title: 'Actual',
                        align: "center",
                        dataIndex: 'Mar_actual',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Mar_actual", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }, {
                        title: 'Budget',
                        align: "center",
                        dataIndex: 'Mar_budget',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Mar_budget", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }, {
                        title: 'Forecast',
                        align: "center",
                        dataIndex: 'Mar_forecast',
                        width: 150,
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: inputIndex.includes(index) ? 'inputNumber' : percentData.includes(index) ? 'percent' : "number", name: "Mar_forecast", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }]
                }]
            }, {
                title: this.state.date - 1,
                align: "center",
                children: [{
                    title: 'Year',
                    align: "center",
                    children: [{
                        title: "Total",
                        align: "center",
                        width: 150,
                        dataIndex: 'total',
                        key: 'total',
                        render: (text, record, index) => {
                            const props = {
                                text, index, type: percentData.includes(index) ? 'percent' : "number", name: "Mar_forecast", onChange: this.onChange, totalIndex: totalData,
                            };
                            if (blankData.includes(index)) {
                                return {
                                    props: {
                                        colSpan: 0,
                                        children: ""
                                    }
                                }
                            }
                            return <TableText data={{ ...props, }} />
                        }
                    }]
                }]
            }];

        return (
            <div className="table table2_1">
                <Row className="title" style={{ width: this.state.print ? 1975 : 'auto' }} id="table2_1">
                    <Row>第一季度 DATA INPUT {this.state.date - 2} and {this.state.date - 1} 数据输入 {this.state.date - 2} and {this.state.date - 1}</Row>
                    <Row className="table-month">
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120 }}
                            value={this.state.date}
                            onChange={(str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                    loading: true
                                });
                                this.getDateData(str)
                            }}
                        >
                            {this.state.dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>

                        <div className="chart_cover">
                            <span>客房数量 : </span>
                            {!this.state.loading ? <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={data[0] ? (Number(data[0].cover) || "") : ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    this.onChange('cover', value, 0);
                                }}
                            /> : null}

                        </div>
                    </Row>
                    <Table
                        columns={columns}
                        dataSource={data}
                        size="middle"
                        className="content"
                        bordered
                        loading={this.state.loading}
                        pagination={false}
                        style={{ width: this.state.print ? 1925 : 'auto' }}
                        scroll={this.state.print ? {} : { x: 1925, y: 500 }}
                        rowKey={(record, index) => {
                            return index
                        }}
                    />

                </Row>
                <Auth loading={this.state.loading} auth='edit_one'>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.downloadSG}
                            loading={this.state.print}
                        >加入pdf</Button>
                        <Button
                            type="primary"
                            onClick={this.onSave}
                            loading={this.state.loadingSave}
                        >保存</Button>
                    </Row>
                </Auth>

            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/charter/first/index.js